/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { ApprovalMode } from "~/generated/graphql";

export const approvalModeOptions = [
  {
    label: "Approve as Scheduled",
    value: ApprovalMode.AsScheduled,
    description:
      "Must be approved within the Action Window. Otherwise, it times out.",
  },
  {
    label: "Approve Whenever",
    value: ApprovalMode.Whenever,
    description: "No deadline. Action remains pending until manually approved.",
  },
] as const;

export function getApprovalModeLabel(approvalMode?: ApprovalMode | null) {
  return (
    approvalModeOptions.find((option) => option.value === approvalMode)
      ?.label ?? "Approval"
  );
}
